import React, { Component, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { strings, getCurrentLocale } from '../../../../localization';
import ReactTable from 'react-table';
import CustomDropDown from '../../../CustomDropDown';
import RavenUtil from '../../../common/ravenUtil';
import ProgressSpinnerSmall from '../../../common/ProgressSpinnerSmall';
import ConfirmDialog from 'APP_ROOT/components/common/ConfirmDialog';
import ProgressOverlay from 'APP_ROOT/components/common/ProgressOverlay';
import BeaconAddModal from '../Beacons/beaconAddModal';
import { DispatchHelpers as AssetMonitoringDispatchHelpers, Selectors as AssetMonitoringSelectors, BEACON_ASSIGNMENT_STATUS, BEACON_VISIBILITY_STATUS } from '../../../../data/assetMonitoring';

class BeaconsPage extends Component {

    state = {
        addBeaconModalOpen: false,
        confirmToggleVisibilityOpen: false,
        beaconIdToToggleVisibility: null,
        errorMessage: null,
    }

    componentDidMount() {
        this.props.loadBeacons()
        .catch((error) => {
            console.error('BeaconsPage: Failed to load beacons', error);
            this.setState({ errorMessage: strings.beacons_loading_error });
        });
    }

    onAddBeacon = () => {
        this.openAddBeaconModal();
    }

    openAddBeaconModal = () => {
        this.setState({ addBeaconModalOpen: true });
    }

    closeAddBeaconModal = () => {
        this.setState({ addBeaconModalOpen: false });
    }
    
    addBeacon = () => {
        this.closeAddBeaconModal();
        // Adding beacons is moved to Support Tool. Here we only show a message to user.
    }

    onToggleBeaconVisibility = (beaconId) => {
        this.setState({ beaconIdToToggleVisibility: beaconId });
        this.openConfirmToggleVisibilityDialog();
    }

    openConfirmToggleVisibilityDialog = () => {
        this.setState({ confirmToggleVisibilityOpen: true });
    }

    closeConfirmToggleVisibilityDialog = () => {
        this.setState({ beaconIdToToggleVisibility: null, confirmToggleVisibilityOpen: false });
    }

    toggleBeaconVisibility = () => {
        this.props.toggleBeaconVisibility(this.state.beaconIdToToggleVisibility)
        .then(() => {
            this.setState({ errorMessage: null });
        })
        .catch((error) => {
            console.error('BeaconsPage: Failed to toggle beacon visibility', error);
            this.setState({ errorMessage: strings.beacons_beacon_toggle_visibility_error });
        });
        
        this.closeConfirmToggleVisibilityDialog();
    }

    renderStats = () => {
    
        const list = this.props.beacons;

        const stats = {};

        const total = list.length;
        const totalLabel = strings.stats_total_label;

        stats[BEACON_VISIBILITY_STATUS.VISIBLE] = list.filter(b => b.visibility === true).length;
        stats[BEACON_VISIBILITY_STATUS.HIDDEN] = list.filter(b => b.visibility === false).length;
        stats[BEACON_ASSIGNMENT_STATUS.ASSIGNED] = list.filter(b => b.assetUuid).length;
        stats[BEACON_ASSIGNMENT_STATUS.UNASSIGNED] = list.filter(b => !b.assetUuid).length;

        return (
            <div className='col-12 stats'>
                <div><label>{totalLabel}: </label><span data-testid="stat-total">{total}</span></div>
                {Object.keys(stats).map(key => {
                    return <div key={key}><label>{strings[`beacons_${key.toLowerCase()}_beacons_label`]}: </label><span data-testid={`stat-${key.toLowerCase()}`}>{stats[key]}</span></div>
                })}
            </div>
        );
    }

    render() {

        const beaconToToggle = this.props.beacons?.find(b => b.beaconUuid === this.state.beaconIdToToggleVisibility);
        const toggleVisibilityConfirmMessage = beaconToToggle && beaconToToggle.visibility
            ? strings.beacons_beacon_hide_beacon_confirm_message
            : strings.beacons_beacon_unhide_beacon_confirm_message;

        const beaconsIntialLoading = this.props.beaconsPending && !this.props.beaconsLoaded;
        const beaconsRefreshing = this.props.beaconsPending && this.props.beaconsLoaded;

        return (
            <div id="beaconsPage" className='container account-page'>
                <div className='row'>
                    {/* title */}
                    <div className="col-6">
                        <h1>{strings.beacons_header}</h1>
                    </div>

                    {/* ADD BEACON button */}
                    <div className="col-md-6 beacons-actions">
                        <button className="btn btn-primary beacons-actions-add-new" onClick={this.onAddBeacon} >
                            <span className='full-label'>{strings.beacons_beacon_add_button_label}</span>
                            <span className='short-label'>{strings.beacons_beacon_add_button_short_label}</span>
                        </button>
                    </div>
                </div>

                {(this.state.errorMessage || this.props.beaconsError) &&
                    <div className='row'>
                        <div className='col-12'>
                            <div className='error-message'>
                                {/* the props.beaconsError is not localized, so we use a generic error message */}
                                {this.state.errorMessage || strings.error_occurred_please_try_again_later}
                            </div>
                        </div>
                    </div>
                }

                {(beaconsIntialLoading) &&
                    <div className='row'>
                        <div className='col-12'>
                            <div className='loading-data'><ProgressSpinnerSmall/><div>{strings.loading_data}</div></div>
                        </div>
                    </div>
                }

                {(this.props.beaconsLoaded) &&
                    <>
                    <div className='row'>
                        {this.renderStats()}
                    </div>

                    <div className='row'>
                        <div className='col-12 instructions'>
                            <span>{strings.formatString(strings.beacons_click_to_x, <i className="material-icons">visibility</i>, <i className="material-icons">visibility_off</i>)}</span>
                        </div>
                    </div>
                
                    <div className='row'>
                        <div className='col-12'>
                            <BeaconsTable
                                beacons={this.props.beacons}
                                onToggleVisibility={this.onToggleBeaconVisibility}
                            />
                        </div>
                    </div>
                    </>
                }

                
                
                <BeaconAddModal isOpen={this.state.addBeaconModalOpen} onCancel={this.closeAddBeaconModal} onSave={this.addBeacon} />

                <ConfirmDialog
                    isOpen={this.state.confirmToggleVisibilityOpen}
                    title={toggleVisibilityConfirmMessage}
                    onOk={this.toggleBeaconVisibility}
                    onCancel={this.closeConfirmToggleVisibilityDialog}
                    onDismiss={this.closeConfirmToggleVisibilityDialog}
                />

                {(this.props.saving || beaconsRefreshing) && <ProgressOverlay />}
                
            </div>
        );
    }
}

class BeaconsTable extends PureComponent {

    newColumn = (header, accessor, overrides = {}) => ({
        Header: header,
        accessor,
        filterable: false,
        className: 'react-table-column',
        headerClassName: 'react-table-column',
        ...overrides,
    });

    getColumns = () => [
        this.newColumn('', 'expander', {
            expander: true,
            width: 45,
            filterable: false,
            sortable: false,
            Cell: row => this.renderExpandActionCell(row),
        }),
        this.newColumn(strings.beacons_beacon_assigned_asset_label, 'assetName', {
            className: 'react-table-grow-column',
            headerClassName: 'react-table-grow-column',
            Placeholder: strings.formatString(strings.placeholder_filter),
            filterable: true,
            Cell: row => this.renderAssetCell(row),
            filterMethod: (filter, row) => {
                const assetName = this.getAssetName(row);
                const btMac = this.getBtMac(row);
                const filterValue = filter.value.toLowerCase();
                return assetName.toLowerCase().includes(filterValue) || btMac.toLowerCase().includes(filterValue);
            }
        }),
        this.newColumn(strings.beacons_beacon_reported_at_label, 'ts', {
            Cell: row => this.renderReportedAtCell(row),
            width: 200,
        }),
        this.newColumn(strings.beacons_beacon_battery_label, 'battery', {
            Cell: row => this.renderBatteryCell(row),
            width: 80,
        }),
        this.newColumn('', 'assetUuid', {
            filterable: true,
            Cell: row => <span>{row.original.assetUuid ? strings.beacons_assigned_beacons_label : strings.beacons_unassigned_beacons_label}</span>,
            width: 150,
            Filter: this.renderAssignmentStatusFilter,
            filterMethod: (filter, row) => {
                if (filter.value === BEACON_ASSIGNMENT_STATUS.ASSIGNED) return !!row.assetUuid;
                if (filter.value === BEACON_ASSIGNMENT_STATUS.UNASSIGNED) return !row.assetUuid;
                return true; // ALL
            },
        }),
        this.newColumn('', 'beaconUuid', {
            width: 110,
            filterable: true,
            Cell: row => this.renderVisibilityActionCell(row),
            Filter: this.renderVisibilityFilter,
            filterMethod: (filter, row) => {
                if (filter.value === BEACON_VISIBILITY_STATUS.VISIBLE) return row._original.visibility === true;
                if (filter.value === BEACON_VISIBILITY_STATUS.HIDDEN) return row._original.visibility === false;
                return true; // ALL
            },
        }),
    ];

    getAssetName = (row) => {
        const { assetName } = row.original || row._original || {};
        
        return assetName || strings.beacons_beacon_not_assigned_message;
    }

    getBtMac = (row) => {
        const { btMac } = row.original || row._original || {};
        return btMac || '-';
    }

    getReportedBy = (row) => {
        const { carPersona, enclosureSerialNo } = row.original || row._original || {};
        return carPersona && enclosureSerialNo ? `${carPersona} [${enclosureSerialNo}]` : '-';
    }

    getBatteryPercentage = (beacon) => {
        return beacon.sensors && beacon.sensors.ASSET_TRACKER_STATUS_BATTERY_PERCENT
            ? beacon.sensors.ASSET_TRACKER_STATUS_BATTERY_PERCENT.value + '%'
            : `-`;
    }

    renderAssetCell = (row) => {
        const assetName = this.getAssetName(row);
        const btMac = this.getBtMac(row);
        const { assetUuid } = row.original;

        if (assetUuid) {
            return (
                <>
                <h3>
                <a href={`/${getCurrentLocale()}/dashboard/assets/${assetUuid}`} target='_blank' rel="noopener noreferrer">
                    <b>{assetName}</b>
                </a></h3>
                <div>{btMac}</div>
                </>
            );
        }

        return (
            <>
            <h3>{btMac}</h3>
            <div>{assetName}</div>
            </>
        )
    }

    renderBatteryCell = (row) => {
        const beacon = row.original;
        const battery = this.getBatteryPercentage(beacon);
        return <span>{battery}</span>;
    }

    renderAssignedAssetForBeacon = (beacon) => {
        if (beacon.assetUuid && beacon.assetName) {
            return (
                <a href={`/${getCurrentLocale()}/dashboard/assets/${beacon.assetUuid}`} target='_blank' rel="noopener noreferrer">
                    <b>{beacon.assetName}</b>
                </a>
            );
        }
        return <span>{strings.beacons_beacon_not_assigned_message}</span>;
    }

    renderReportedAtCell = (row) => {
        const { carPersona, enclosureSerialNo, ts } = row.original;
        const hasBeenSeen = carPersona && enclosureSerialNo;
        return <span>{hasBeenSeen ? RavenUtil.toDateString(new Date(ts * 1000)) : '-'}</span>;
    }

    renderVisibilityActionCell = (row) => {
        const icon = row.original.visibility ? <i className='material-icons hide-beacon'>visibility_off</i> : <i className='material-icons'>visibility</i>;
        const tooltip = row.original.visibility ? strings.beacons_beacon_hide_button_label : strings.beacons_beacon_unhide_button_label;
        return (
            <button className="btn-icon btn-outline-transparent" onClick={() => this.props.onToggleVisibility(row.original.beaconUuid)} title={tooltip}>
                {icon}
            </button>
        );
    }

    renderExpandActionCell = ({ isExpanded }) => {
        const icon = isExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
        const tooltip = isExpanded ? 'Collapse' : 'Expand';
        return <i className='material-icons' title={tooltip}>{icon}</i>;
    }

    renderExpandedBeaconDetails = (row) => {
        const beacon = row._original || row.original;
        const hasBeenSeen = beacon.carPersona && beacon.enclosureSerialNo;

        return (
            <div className="beacon-card">
                <div className='beacon-details'>
                    <div className="beacon-details-item"><label>{strings.beacons_beacon_assigned_asset_label}: </label><span>{this.renderAssignedAssetForBeacon(beacon)}</span></div>
                    <div className="beacon-details-item"><label>{strings.beacons_beacon_battery_label}: </label><span>{this.getBatteryPercentage(beacon)}</span></div>
                    <div className="beacon-details-item"><label>{strings.beacons_beacon_reported_at_label}: </label><span>{hasBeenSeen ? RavenUtil.toDateString(new Date(beacon.ts * 1000)) : '-'}</span></div>
                    <div className="beacon-details-item"><label>{strings.beacons_beacon_reported_by_label}: </label><span>{hasBeenSeen ? `${beacon.carPersona} [${beacon.enclosureSerialNo}]` : '-'}</span></div>
                    <div className="beacon-details-item"><label>{strings.beacons_beacon_btmac_label}: </label><span>{beacon.btMac}</span></div>
                    <div className="beacon-details-item"><label>{strings.beacons_beacon_make_label}: </label><span>{beacon.make || '-'}</span></div>
                    <div className="beacon-details-item"><label>{strings.beacons_beacon_model_label}: </label><span>{beacon.model || '-'}</span></div>
                </div>
            </div>
        );
    }

    renderVisibilityFilter = ({filter, onChange}) => {
        const value = filter ? filter.value : BEACON_VISIBILITY_STATUS.ALL;
        const items = [
            { value: BEACON_VISIBILITY_STATUS.ALL, label: strings.beacons_see_all_option_label },
            { value: BEACON_VISIBILITY_STATUS.VISIBLE, label: strings.beacons_see_visibles_option_label },
            { value: BEACON_VISIBILITY_STATUS.HIDDEN, label: strings.beacons_see_hiddens_option_label },
        ];

        return (
            <CustomDropDown
                className='react-table-header-filter'
                items={items}
                selectedItems={value}
                onChange={onChange}
                closeOnChange
                required
            />
        );
    }

    renderAssignmentStatusFilter = ({filter, onChange}) => {
        const value = filter ? filter.value : BEACON_ASSIGNMENT_STATUS.ALL;
        const items = [
            { value: BEACON_ASSIGNMENT_STATUS.ALL, label: strings.beacons_see_all_option_label },
            { value: BEACON_ASSIGNMENT_STATUS.ASSIGNED, label: strings.beacons_see_assigned_option_label },
            { value: BEACON_ASSIGNMENT_STATUS.UNASSIGNED, label: strings.beacons_see_unassigned_option_label },
        ];

        return (
            <CustomDropDown
                className='react-table-header-filter'
                items={items}
                selectedItems={value}
                onChange={onChange}
                closeOnChange
                required
            />
        );
    }

    columns = this.getColumns();

    render() {
        const { beacons } = this.props;

        return (
            <ReactTable
                filterable={true}
                sortable={false}
                showPagination={false}
                minRows={0}
                data={beacons}
                noDataText={strings.no_match_for_selected_filters}
                defaultFiltered={[{ id: 'beaconUuid', value: BEACON_VISIBILITY_STATUS.VISIBLE }]}
                columns={this.columns}
                getTrProps={() => ({ className: '-rollup' })}
                SubComponent={row => this.renderExpandedBeaconDetails(row)}
            />
        );
    }
}

BeaconsPage.propTypes = {
    beacons: PropTypes.array.isRequired,
    loadBeacons: PropTypes.func.isRequired,
    toggleBeaconVisibility: PropTypes.func.isRequired,
    saving: PropTypes.bool,
    beaconsLoaded: PropTypes.bool,
    beaconsPending: PropTypes.bool,
    beaconsError: PropTypes.any,
};

BeaconsTable.propTypes = {
    beacons: PropTypes.array.isRequired,
    onToggleVisibility: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
    return {
        beaconsLoaded: AssetMonitoringSelectors.beaconsLoaded(state),
        beaconsPending: AssetMonitoringSelectors.beaconsPending(state),
        beaconsError: AssetMonitoringSelectors.beaconsError(state),
        beacons: AssetMonitoringSelectors.beacons(state),
        saving: AssetMonitoringSelectors.beaconsSavePending(state),
    };
};

const mapDispatchToProps = (dispatch, ownProps) =>{
    return{
        loadBeacons: () => dispatch(AssetMonitoringDispatchHelpers.loadBeacons()),
        toggleBeaconVisibility: (beaconId) => dispatch(AssetMonitoringDispatchHelpers.toggleBeaconVisibility(beaconId)),
    }
};

export { BeaconsPage as UnconnectedBeaconsPage }; // Added for testing
export default connect(mapStateToProps, mapDispatchToProps)(BeaconsPage);